/**
 * 사이드바 메뉴 설정
 */

import {
  Wine,
  Tag,
  Image,
  MessageSquare,
  FileText,
  Users,
  UsersRound,
  List,
  Plus,
  LayoutDashboard,
  ChartLine,
  Layers,
  Factory,
  FileSpreadsheet,
  MapPinned,
  FileSearch,
  Shapes,
  SlidersHorizontal,
} from 'lucide-react';
import type { MenuGroup } from '@/types/menu';

export const menuConfig: MenuGroup[] = [
  {
    id: 'dashboard',
    items: [
      {
        id: 'dashboard',
        label: '대시보드',
        icon: LayoutDashboard,
        path: '/',
      },
      {
        id: 'statistics',
        label: '통계',
        icon: ChartLine,
        roles: ['ROOT_ADMIN'],
        children: [
          {
            id: 'visitor-statistics',
            label: '방문자 통계',
            icon: UsersRound,
            path: '/statistics/visitors',
          },
          {
            id: 'alcohol-statistics',
            label: '주류 통계',
            icon: Wine,
            path: '/statistics/alcohols',
          },
        ],
      },
      {
        id: 'dashboard-curation',
        label: '큐레이션',
        icon: Layers,
        path: '/dashboard/curations',
        roles: ['ROOT_ADMIN', 'BAR_OWNER', 'COMMUNITY_MANAGER'],
      },
    ],
  },
  {
    id: 'whisky-tasting',
    items: [
      {
        id: 'whisky-tasting-menu',
        label: '위스키/테이스팅 태그',
        icon: Wine,
        roles: ['ROOT_ADMIN'],
        children: [
          {
            id: 'whisky-management',
            label: '위스키 정보 관리',
            icon: Wine,
            children: [
              {
                id: 'whisky-list',
                label: '위스키 목록',
                icon: List,
                path: '/whisky',
              },
              {
                id: 'whisky-create',
                label: '위스키 추가',
                icon: Plus,
                path: '/whisky/new',
              },
              {
                id: 'whisky-excel-bulk',
                label: '위스키 Excel 벌크 등록',
                icon: FileSpreadsheet,
                path: '/whisky/excel-bulk',
              },
              {
                id: 'alcohol-attribute-management',
                label: '속성 관리',
                icon: SlidersHorizontal,
                path: '/alcohol-attributes',
              },
            ],
          },
          {
            id: 'tasting-tag-management',
            label: '테이스팅 태그 관리',
            icon: Tag,
            children: [
              {
                id: 'tasting-tag-list',
                label: '테이스팅 태그 목록',
                icon: List,
                path: '/tasting-tags',
              },
              {
                id: 'tasting-tag-create',
                label: '태그 추가',
                icon: Plus,
                path: '/tasting-tags/new',
              },
              {
                id: 'tasting-group-management',
                label: '그룹 관리',
                icon: Shapes,
                path: '/tasting-groups',
              },
            ],
          },
          {
            id: 'region-management',
            label: '지역 관리',
            icon: MapPinned,
            children: [
              {
                id: 'region-list',
                label: '지역 목록',
                icon: List,
                path: '/regions',
              },
              {
                id: 'region-create',
                label: '지역 추가',
                icon: Plus,
                path: '/regions/new',
              },
            ],
          },
          {
            id: 'distillery-management',
            label: '증류소 관리',
            icon: Factory,
            children: [
              {
                id: 'distillery-list',
                label: '증류소 목록',
                icon: List,
                path: '/distilleries',
              },
              {
                id: 'distillery-create',
                label: '증류소 추가',
                icon: Plus,
                path: '/distilleries/new',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'mfds',
    items: [
      {
        id: 'mfds-management',
        label: '식약처 데이터 관리',
        icon: FileSearch,
        roles: ['ROOT_ADMIN'],
        children: [
          {
            id: 'mfds-declaration-list',
            label: '수입 신고 데이터 검토',
            icon: List,
            path: '/mfds/declarations',
          },
          {
            id: 'mfds-importer-list',
            label: '수입사 관리',
            icon: Factory,
            path: '/mfds/importers',
          },
        ],
      },
    ],
  },
  {
    id: 'banner',
    items: [
      {
        id: 'banner-management',
        label: '배너 관리',
        icon: Image,
        roles: ['ROOT_ADMIN'],
        children: [
          {
            id: 'banner-list',
            label: '배너 목록',
            icon: List,
            path: '/banners',
          },
          {
            id: 'banner-create',
            label: '배너 추가',
            icon: Plus,
            path: '/banners/new',
          },
        ],
      },
    ],
  },
  {
    id: 'campaign-content',
    items: [
      {
        id: 'campaign-content-management',
        label: '캠페인 콘텐츠 관리',
        icon: Layers,
        roles: ['ROOT_ADMIN'],
        children: [
          {
            id: 'campaign-content-list',
            label: '캠페인 콘텐츠 목록',
            icon: List,
            path: '/campaign-contents',
          },
          {
            id: 'campaign-content-create',
            label: '캠페인 콘텐츠 추가',
            icon: Plus,
            path: '/campaign-contents/new',
          },
        ],
      },
    ],
  },
  {
    id: 'inquiry',
    items: [
      {
        id: 'inquiry-management',
        label: '문의 관리',
        icon: MessageSquare,
        roles: ['ROOT_ADMIN'],
        children: [
          {
            id: 'inquiry-list',
            label: '문의 목록',
            icon: List,
            path: '/inquiries',
          },
        ],
      },
    ],
  },
  {
    id: 'policy',
    items: [
      {
        id: 'policy-management',
        label: '정책/방침 관리',
        icon: FileText,
        path: '/policies',
        roles: ['ROOT_ADMIN'],
      },
    ],
  },
  {
    id: 'user',
    items: [
      {
        id: 'user-management',
        label: '사용자 관리',
        icon: Users,
        path: '/users',
        roles: ['ROOT_ADMIN'],
      },
    ],
  },
  {
    id: 'review',
    items: [
      {
        id: 'review-management',
        label: '리뷰 관리',
        icon: MessageSquare,
        path: '/reviews',
        roles: ['ROOT_ADMIN'],
      },
    ],
  },
];
